import React from "react";
import {
  FaUtensils,
  FaLeaf,
  FaAppleAlt,
  FaCheckCircle,
  FaUsers,
  FaShieldAlt,
  FaClock,
  FaSmile,
} from "react-icons/fa";
const features = [
  "Fresh & hygienic food",
  "Nutritious meal options",
  "Clean dining environment",
  "Student-friendly service",
  "Safe drinking water",
  "Healthy food habits",
];
const foodCards = [
  {
    title: "Hygienic Preparation",
    icon: <FaShieldAlt />,
    desc: "Food is prepared with proper cleanliness and care.",
  },
  {
    title: "Balanced Nutrition",
    icon: <FaAppleAlt />,
    desc: "Meals are planned to support student health and energy.",
  },
  {
    title: "Fresh Ingredients",
    icon: <FaLeaf />,
    desc: "Fresh and quality ingredients are used for better taste.",
  },
  {
    title: "Comfortable Seating",
    icon: <FaUsers />,
    desc: "A clean and comfortable space for students to enjoy meals.",
  },
];
const Cafeteria = () => {
  return (
    <section className="relative py-20 px-4 md:px-10 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-80 h-80 bg-orange-300/20 rounded-full blur-3xl -translate-x-32"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-red-300/20 rounded-full blur-3xl translate-x-32"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-5 py-2 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
            Cafeteria
          </span>
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            Healthy & Hygienic{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              School Cafeteria
            </span>
          </h1>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto text-sm md:text-base leading-7">
            A clean and comfortable cafeteria that provides fresh, nutritious
            and tasty food for students.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 items-start">
          <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-8 text-white shadow-2xl">
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center text-2xl mb-5">
              <FaUtensils />
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold mb-4">
              Fresh Food, Better Health
            </h2>
            <p className="text-white/90 text-sm leading-7 mb-6">
              Our cafeteria focuses on hygiene, nutrition and student comfort.
              Food is served in a clean environment to encourage healthy eating
              habits.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {features.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-white/15 border border-white/20 rounded-2xl p-4"
                >
                  <FaCheckCircle className="text-yellow-200 shrink-0" />
                  <span className="text-sm font-semibold">{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {foodCards.map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-[26px] p-6 shadow-xl border border-orange-100 hover:-translate-y-1 hover:shadow-2xl transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-r from-red-600 to-orange-500 text-white flex items-center justify-center text-xl mb-4">
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 leading-7">
                  {item.desc}
                </p>
              </div>
            ))}
            <div className="sm:col-span-2 bg-white rounded-[26px] p-6 shadow-xl border border-orange-100">
              <div className="flex flex-col md:flex-row gap-5">
                <div className="flex items-start gap-3 flex-1">
                  <FaClock className="text-red-500 text-xl mt-1" />
                  <div>
                    <h4 className="font-bold text-gray-900">Meal Time</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Served during school break under proper supervision.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3 flex-1">
                  <FaSmile className="text-orange-500 text-xl mt-1" />
                  <div>
                    <h4 className="font-bold text-gray-900">Student Care</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Friendly service with focus on student comfort and safety.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 bg-white rounded-[26px] p-6 md:p-8 shadow-lg border border-orange-100 text-center">
          <p className="text-gray-600 text-sm md:text-base leading-7 max-w-3xl mx-auto">
            The cafeteria supports healthy eating habits and provides a safe,
            clean and pleasant environment where students can refresh and enjoy
            their meals.
          </p>
        </div>
      </div>
    </section>
  );
};
export default Cafeteria;